import { store } from 'redux/store';
import { authInitState } from 'redux/reducers/auth/reducer';
import { ID_URL } from 'services/constants/env';
import { PATHS } from 'routes/constants';
import { IAxiosError, IAxiosRequestConfig } from './types';

// ==========================================:
export const onError = (error: IAxiosError) => {
	const status = error.response ? error.response.status : null;
	const errorResponse: IAxiosRequestConfig = error.config;
	const state = store.getState();

	const isUserApiRequest = errorResponse?.url === '/api/user';
	const isTokenCodeRequest = errorResponse?.url === '/api/user/token/code';

	if (error.message === 'Request aborted') {
		console.warn('Request was aborted:', {
			url: errorResponse?.url,
			method: errorResponse?.method,
			timestamp: new Date().toISOString(),
		});

		if (isTokenCodeRequest) {
			console.warn('Authorization code exchange request was aborted');
			store.dispatch(authInitState());
			window.location.assign(ID_URL);
			return Promise.reject(error);
		}

		return Promise.reject(error);
	}

	// Check error type
	if (error.message === 'Network Error') {
		const requestInfo = {
			url: errorResponse?.url,
			method: errorResponse?.method?.toUpperCase(),
			baseURL: errorResponse?.baseURL,
			headers: errorResponse?.headers,
		};

		if (isUserApiRequest || isTokenCodeRequest) {
			console.warn('Authentication problem when requesting user data');
			store.dispatch(authInitState());
			window.location.assign(ID_URL);
			return Promise.reject(error);
		}

		return Promise.reject(error);
	}

	// Handle 401 error
	if (status === 401 || error.response?.status === 401) {
		const requestInfo = {
			url: errorResponse?.url,
			method: errorResponse?.method?.toUpperCase(),
			baseURL: errorResponse?.baseURL,
			headers: errorResponse?.headers,
		};

		console.warn('Authorization error (401):', {
			requestInfo,
			timestamp: new Date().toISOString(),
			authState: state.auth,
			errorStatus: status,
			responseStatus: error.response?.status,
		});

		// Special handling for authentication-related requests
		// if (isUserApiRequest || isTokenCodeRequest) {
		// 	console.warn('User session expired or invalid');
		// 	store.dispatch(authInitState());
		// 	window.location.assign(ID_URL);
		// 	return Promise.reject(error);
		// }

		// Handle other 401 errors
		if (!errorResponse._retry) {
			console.log('errorResponse._retry', errorResponse._retry);
			console.log('state.auth?.inactivityLogout', state.auth?.inactivityLogout);
			if (state.auth?.inactivityLogout) {
				window.location.href = PATHS.INACTIVITY_PAGE;
			} else {
				store.dispatch(authInitState());
				window.location.assign(ID_URL);
			}
		}
	}

	return Promise.reject(error);
};
